import React from "react";
import { useSearchParams } from "react-router-dom";
import IntegracaoIaService from "../../services/IntegracaoIaService";
import BtnButton from "../../components/forms/elements/BtnButton";
import { toast } from "react-toastify";

function AutorizarAplicativoInner() {
    const [params] = useSearchParams();
    const pedido = params.get("pedido") || "";
    const [dados, setDados] = React.useState(null);
    const [pacotesSel, setPacotesSel] = React.useState([]);
    const [carregando, setCarregando] = React.useState(true);
    const [processando, setProcessando] = React.useState(null);
    const processandoRef = React.useRef(false);

    React.useEffect(() => {
        if (!pedido) {
            setCarregando(false);
            return;
        }
        IntegracaoIaService.getConsentimento(pedido, (resp, err) => {
            setCarregando(false);
            if (err || !resp) {
                toast.error("Não foi possível carregar a autorização.");
                return;
            }
            setDados(resp);
            setPacotesSel((resp.pacotes || []).map((p) => p.codigo));
        });
    }, [pedido]);

    const togglePacote = (codigo) => {
        setPacotesSel((prev) =>
            prev.includes(codigo) ? prev.filter((c) => c !== codigo) : [...prev, codigo]
        );
    };

    const enviar = (aprovar) => {
        if (processandoRef.current) return;
        processandoRef.current = true;
        setProcessando(aprovar ? "autorizar" : "recusar");
        IntegracaoIaService.postConsentimento(
            pedido,
            { aprovar, pacotes: pacotesSel },
            (resp, err) => {
                if (err || !resp || !resp.redirect) {
                    processandoRef.current = false;
                    setProcessando(null);
                    toast.error(aprovar ? "Falha ao autorizar. Tente de novo." : "Falha ao recusar. Tente de novo.");
                    return;
                }
                setProcessando(aprovar ? "redirecionando" : "recusando");
                window.location.href = resp.redirect;
            },
            { showLoadding: false }
        );
    };

    const mensagemProcessando = {
        autorizar: "Aguarde. Autorizando o aplicativo…",
        redirecionando: "Autorizado. Voltando para o aplicativo…",
        recusar: "Aguarde. Recusando o acesso…",
        recusando: "Acesso recusado. Voltando para o aplicativo…",
    }[processando];

    if (carregando) {
        return <div className="container py-5 text-center">Carregando…</div>;
    }

    if (!pedido || !dados) {
        return (
            <div className="container py-5">
                <div className="alert alert-warning">Autorização inválida ou expirada.</div>
            </div>
        );
    }

    return (
        <div className="container py-5" style={{ maxWidth: 560 }}>
            <h1 className="h4 mb-3">Autorizar aplicativo</h1>
            <p className="text-muted">
                <strong>{dados.nmAplicativo}</strong> solicita acesso somente leitura aos dados da BDM.
            </p>
            <p className="small">
                Somente leitura. O aplicativo não grava, não cobra e não apaga dados.
            </p>
            <div className="mb-4">
                {(dados.pacotes || []).map((p) => (
                    <div className="form-check" key={p.codigo}>
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id={"pkg-" + p.codigo}
                            checked={pacotesSel.includes(p.codigo)}
                            disabled={!!processando}
                            onChange={() => togglePacote(p.codigo)}
                        />
                        <label className="form-check-label" htmlFor={"pkg-" + p.codigo}>
                            {p.rotulo}
                        </label>
                    </div>
                ))}
            </div>
            {mensagemProcessando && (
                <div className="alert alert-info d-flex align-items-center gap-2" role="status">
                    <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                    <span>{mensagemProcessando}</span>
                </div>
            )}
            <div className="d-flex gap-2">
                <BtnButton type="button" className="btn btn-primary" disabled={!!processando} onClick={() => enviar(true)}>
                    {processando === "autorizar" || processando === "redirecionando" ? "Aguarde…" : "Autorizar"}
                </BtnButton>
                <BtnButton type="button" className="btn btn-outline-secondary" disabled={!!processando} onClick={() => enviar(false)}>
                    {processando === "recusar" || processando === "recusando" ? "Aguarde…" : "Recusar"}
                </BtnButton>
            </div>
        </div>
    );
}

export default function AutorizarAplicativo() {
    return <AutorizarAplicativoInner />;
}
